import React from 'react';
import { IconCogs } from '../../utils/icons';

const LoadingSpinner = () => {
	return (
		<div className="content">
			<div className="spinner loading-spinner">
				<div className="cog">
					<IconCogs />
				</div>
				<p>Vent et øjeblik...</p>
			</div>
		</div>
	);
};

export default LoadingSpinner;